/** @jsx jsx */
import { jsx } from 'theme-ui';
import PropTypes from 'prop-types';
import Link from '../link';

export const Container = (props) => (
  <div
    sx={{
      padding: ['8rem 4vw', '9.8rem 4vw', '7.6rem 6.4rem'],
      backgroundColor: 'White',
    }}
    {...props}
  />
);

export const Header = (props) => (
  <header
    sx={{
      h1: {
        fontWeight: 400,
        color: 'SecondaryBlue2',
      },
      p: {
        color: 'PrimaryDarkBlue',
      },
    }}
    {...props}
  />
);

export const LinkImagesContainer = (props) => (
  <div
    sx={{
      marginTop: '6.5rem',
      display: 'flex',
      flexFlow: ['column nowrap', 'row wrap'],
      justifyContent: 'space-between',
    }}
    {...props}
  />
);

export const LinkContainer = (props) => (
  <Link
    sx={{
      width: ['100%', 'calc(50% - 1.4rem)', 'calc(33% - 3.2rem)'],
      height: '225px',
      marginBottom: '3rem',
      position: 'relative',
      boxShadow:
        '0 2px 2px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.12)',
      backgroundColor: 'PrimaryBrightBlue',
      transition: 'box-shadow .25s ease-out',

      '&:last-of-type': {
        marginBottom: '0',
      },
      '&:hover': {
        boxShadow:
          '0 8px 8px 0 rgba(0, 0, 0, 0.24), 0 4px 8px 0 rgba(0, 0, 0, 0.12)',
      },
      '&:active': {
        transition: 'box-shadow .125s ease-in',
        boxShadow:
          '0 2px 2px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.12)',
      },
      '> span': {
        display: 'block',
        padding: '1rem 1.5rem',
        backgroundColor: '#f1f5f7',
        width: '100%',
        fontSize: '1.8rem',
        lineHeight: 1.44,
        color: 'text',
        fontWeight: 'bold',
        position: 'absolute',
        bottom: 0,
        textDecoration: 'none',
      },
    }}
    {...props}
  />
);


export const ImageContainer = (props) => {
  const { isIcon } = props;
  let img = {};
  if (isIcon === true) {
    img = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      maxHeight: '120px',
    };
  } else {
    img = {
      height: '100%',
      position: 'absolute',
      top: '50%',
      left: '50%',
      //'margin-right': '-50%',
      transform: 'translate(-50%, -50%)',
    };
  }
  return (
    <div
      sx={{
        overflowY: 'hidden',
        overflowX: 'hidden',
        height: '180px',
        position: 'relative',
        img,
      }}
      {...props}
    />
  );
};

ImageContainer.propTypes = {
  isIcon: PropTypes.bool.isRequired,
};
